import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import Shortcuts from '../Elements/Shortcuts';

/**
 * Shortcut Controller
 *
 * @class
 */
class ShortcutController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
    this._registerElements(Shortcuts);
  }
}

export default new ShortcutController();
